<script>
import GuaranteedTableFilters from '@components/candidate/guaranteed-table-filters.vue'
import CandidateAvailabilityChart from '@components/candidate/availability-chart.vue'
import ConsultantDetails from '@components/general/consultant-details.vue'
import PlacementTodays from '@components/placements/placement-todays.vue'
import PlacementPeriod from '@components/placements/placement-period.vue'

import { mapActions } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import ClientDetailsListItem from '../general/client-details-list-item.vue'
import DateComponent from '../general/date-component.vue'
export default {
  components: {
    GuaranteedTableFilters,
    CandidateAvailabilityChart,
    ConsultantDetails,
    PlacementTodays,
    ClientDetailsListItem,
    DateComponent,
    PlacementPeriod,
  },
  mixins: [baseMixin],
  props: {},
  data() {
    return {
      loading: false,
      filter: {},
      selectedType: 0,
      headers: [
        {
          text: 'Needs Attention',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        { text: 'Client', value: 'prefClientId' },
        { text: 'Name', value: 'name' },
        { text: 'Owner', value: 'owner' },
        { text: 'Date From', value: 'dateFrom' },
        { text: 'Date Until', value: 'dateUntil' },
        { text: 'Days', value: 'daysPerWeek' },
        { text: 'Bookings in Week', value: 'bookingsInWeek' },
        // { text: 'Team', value: 'team.Name' },
        // { text: 'Availability', value: 'availability' },
        { text: 'Todays Booking', value: 'todaysBookingID' },
      ],
      guaranteedList: [],
    }
  },
  computed: {
    returnHeaders() {
      switch (this.filter.type) {
        case 'SUB_BUBBLES':
        case 'TEACH_START':
          return this.headers.filter((t) => t.value !== 'daysPerWeek')
        case 'AMBASSADORS':
          return this.headers.filter((t) => t.value !== 'prefClientId')
        default:
          return this.headers.filter((t) => t.value !== 'prefClientId')
      }
    },
    returnItems() {
      if (this.loading) {
        return []
      } else {
        return this.guaranteedList
      }
    },
  },
  methods: {
    ...mapActions({
      returnGuaranteedList: 'candidate/returnGuaranteedList',
    }),
    guaranteedFiltersChanged(payload) {
      this.filter = payload
      // check payload is different prior to going off to load list
      this.loadList(payload)
    },
    async loadList(payload) {
      this.loading = true

      const result = await this.returnGuaranteedList(payload)
      this.guaranteedList = result.data

      this.loading = false
    },
  },
}
</script>

<template>
  <div class="task-item">
    <GuaranteedTableFilters
      :disabled="loading"
      @guaranteed-filters-changed="guaranteedFiltersChanged"
    ></GuaranteedTableFilters>

    <v-row>
      <v-col>
        <v-data-table
          :headers="returnHeaders"
          :items="returnItems"
          class="custom-elevation rounded-xl"
        >
          <template v-slot:item.status="{ item }">
            <div v-if="item.bookingsInWeek > item.bookings.length">
              <v-icon>mdi-alert</v-icon>
            </div>
          </template>

          <template v-slot:item.prefClientId="{ item }">
            <ClientDetailsListItem
              :location-id="item.prefLocationId"
              :group-id="item.prefGroupId"
              :client-id="item.prefClientId"
            >
            </ClientDetailsListItem>
          </template>
          <template v-slot:item.name="{ item }">
            <BaseLink
              :href="returnCandidateUrl(item.candidateID)"
              color="primary"
              :title="$t('general.link.viewCandidateTooltip')"
              allow-insecure
              >{{ item.name }}</BaseLink
            >
          </template>
          <template v-slot:item.dateFrom="{ item }">
            <DateComponent :date="item.dateFrom"></DateComponent>
          </template>

          <template v-slot:item.dateUntil="{ item }">
            <DateComponent :date="item.dateUntil"></DateComponent>
          </template>

          <template v-slot:item.owner="{ item }">
            <ConsultantDetails :id="item.ownerID"></ConsultantDetails>
          </template>
          <template v-slot:item.todaysBookingID="{ item }">
            <PlacementTodays
              :date="filter.date"
              :bookings="item.bookings"
            ></PlacementTodays>
          </template>
          <template v-slot:item.bookingsInWeek="{ item }">
            <PlacementPeriod :bookings="item.bookings"></PlacementPeriod>
          </template>
          <template v-slot:item.availability="{ item }">
            <CandidateAvailabilityChart
              :data="item.availability"
            ></CandidateAvailabilityChart>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
